export const LESSON_TYPE = {
  ASSESSMENT: "ASSESSMENT",
  AI_TUTOR: "AI_TUTOR",
  READ_ALOUD: "READ_ALOUD",
  STUDY_SET: "STUDY_SET",
  PRONUNCIATION: "PRONUNCIATION",
  CONVERSATION: "CONVERSATION"
}